'use strict';
import "../../_scripts/inrt.js";
import { isTouch } from "../../_scripts/helpers";

export default class ThumbsSlider {
	constructor(el, slider) {
        this.root = el;
        if (!this.root) return false;
        this.thumbsContainer = this.root.querySelector("[data-thumbs]");
        this.id = this.thumbsContainer.id;
        this.slider = slider;
        this.activeSlide = 0;
        this.touch = isTouch();
        this._matchHTML();
        this._init();
	}

	_matchHTML() {
        this.thumbs = [...this.root.querySelectorAll("[data-thumb]")];
        this.prevBtn = this.root.querySelector("[data-prev]");
        this.nextBtn = this.root.querySelector("[data-next]");
    }
    
    _init() {
        this.thumbs.forEach((thumb, index) => {
            thumb.dataset.thumbId = index;
            thumb.addEventListener("click", () => {
                this.slider.goTo(index);
                this.goTo(index);
			});
        });
        this.thumbsCount = this.thumbs.length;
        if (this.prevBtn && this.nextBtn) {
            this.prevBtn.addEventListener("click", this.prev.bind(this));
            this.nextBtn.addEventListener("click", this.next.bind(this));
        }
        const cs = window.getComputedStyle(this.thumbsContainer);
        if (((this.thumbsContainer.scrollWidth >= this.thumbsContainer.offsetWidth) && cs.flexDirection === "row") 
            || ((this.thumbsContainer.scrollHeight >= Number(cs.maxHeight.replace(/\D/g,''))) && cs.flexDirection !== "row")) {
            this._showArrows();
        }
        if (!this.touch) {
            new inrt.scroller({elementId: this.id});
            this._dragFix();
        } else {
            this.thumbsContainer.classList.add("has-scroll");
        }
        this.goTo(this.activeSlide);
    }

    _showArrows() {
        if (this.prevBtn && this.nextBtn) { 
            this.nextBtn.classList.remove("is-hidden");
            this.prevBtn.classList.remove("is-hidden");
        }
    }

    _dragFix() {
        var flagdrag = false,
            flagdown = false,
            timeout;
        $(this.root).on({
            mousemove: function(e) {
                if (flagdown) flagdrag = true;
                if (flagdrag) {
                    $(this).find('[data-thumb]').css({
                        'pointer-events': 'none'
                    });
                }
            },
            mousedown: function(e) {
                e.preventDefault();
                timeout = setTimeout(function() {
                    flagdown = true;
                }, 100);
            },
            mouseup: function(e) {
                clearTimeout(timeout);
                flagdown = false;
                flagdrag = false;
                $(this).find('[data-thumb]').removeAttr('style');
            }
        });
    }

    goTo(index, sync = true) {
        if (index + 1 > this.thumbsCount || index + 1 < 0) return;
        const row = window.getComputedStyle(this.thumbsContainer).flexDirection === "row";

        this.thumbs.forEach((thumb) => {
            if (thumb.dataset.thumbId == index) {
                thumb.firstElementChild.classList.add("is-active");
                let thumbRect = thumb.getBoundingClientRect();
                let containerRect = thumb.parentElement.getBoundingClientRect();
                if (row) {
                    if (thumbRect.right > containerRect.right) {
                        thumb.parentElement.scrollLeft = thumb.offsetLeft - (containerRect.width - thumbRect.width);
                    } else if (thumbRect.left < containerRect.left) {
                        thumb.parentElement.scrollLeft = thumb.offsetLeft;
                    }
                } else {
                    if (thumbRect.bottom > containerRect.bottom) {
                        thumb.parentElement.scrollTop = thumb.offsetTop - (containerRect.height - thumbRect.height);
                    } else if (thumbRect.top < containerRect.top) {
                        thumb.parentElement.scrollTop = thumb.offsetTop;
                    }
                }
            } else {
                thumb.firstElementChild.classList.remove("is-active");
            }
        });

        if (this.prevBtn && this.nextBtn) { 
            this.nextBtn.classList.remove("is-disabled");
            this.prevBtn.classList.remove("is-disabled");
    
            if (index + 1 == this.thumbsCount) {
                this.nextBtn.classList.add("is-disabled");
            } else if (index == 0) {
                this.prevBtn.classList.add("is-disabled");
            }
        }

        if (sync) this.slider.goTo(index);
        
        this.activeSlide = index;
    }

    next() {
        this.goTo(this.activeSlide + 1);
    }

    prev() {
        this.goTo(this.activeSlide - 1);
    }
}
